import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99442e92"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99442e92')) {
      api.createRecord('99442e92', component.options)
    } else {
      api.reload('99442e92', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=99442e92", function () {
      api.rerender('99442e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/ShippingInstructions/index.vue"
export default component.exports